<template>
  <v-row no-gutters justify="end">
    <v-btn
      small
      color="primary"
      text
      class="mx-2"
      :to="{ name: 'restoran-id-korisnici', params: { id: item.id } }"
    >
      {{ $t("users") }} {{ item.users_count }}
    </v-btn>
    <circle-button
      v-if="isAdmin"
      icon="mdi-link-variant"
      :tooltip="$t('link_supplier_restaurant')"
      color="primary"
      class="mr-1"
      @click="$emit('openLinkDialog')"
    />
    <edit-button class="mr-2" @click="$emit('edit', item)" />
    <remove-button @click="$emit('delete', item)" />
  </v-row>
</template>

<script>
export default {
  name: "RestaurantActions",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ["edit", "delete", "openLinkDialog"],
  computed: {
    isAdmin() {
      return this.$store.state.user?.user?.type === "admin";
    },
  },
};
</script>
